'use strict';Object.defineProperty(exports,'__esModule',{value:!0});var createShape=function(options){var _options$borderStyle=options.borderStyle,borderStyle=_options$borderStyle===void 0?'solid':_options$borderStyle,_options$borderWidth=options.borderWidth,borderWidth=_options$borderWidth===void 0?'1px':_options$borderWidth,_options$borderRadius=options.borderRadius,borderRadius=_options$borderRadius===void 0?'4px':_options$borderRadius;return{borderStyle:borderStyle,borderWidth:borderWidth,borderRadius:borderRadius}};exports.default=createShape;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@vitalsource/vstui/themes/createShape.js
// module id = 552
// module chunks = 162